import { useGetShippingByNumberQuery } from '../../../Shippings/services/shippings.service';
import { ArrivalScanResponse } from '../../services/arrivalScan.endpoints';
import ShippingIdentifier from './ScannedItemCard/ShippingIdentifier';
import ShippingDetails from './ScannedItemCard/ShippingDetails';
import ShippingStatus from './ScannedItemCard/ShippingStatus';
import { Paper } from '@mui/material';
import React from 'react';
import { appUrl } from '@/utils/appUrl';

interface ScannedItemCardProps {
  item: ArrivalScanResponse;
  index: number;
}

const ScannedItemCard: React.FC<ScannedItemCardProps> = ({ item, index }) => {
  const isFirst = index === 0;

  const { data: shipping, isLoading } = useGetShippingByNumberQuery({
    number: String(item.shippingNumber)
  });

  const handleCardClick = () => {
    window.open(appUrl(`/business/shipping/${item.shippingNumber}`), '_blank');
  };

  return (
    <Paper
      elevation={0}
      className='p-4 border border-gray-100 rounded-md flex items-center justify-between transition-all duration-200 relative bg-white min-h-[80px]'
      style={isFirst ? { borderLeft: '4px solid #ff7500' } : {}}
    >
      <div className='flex items-center gap-6 flex-1 min-w-0'>
        <ShippingIdentifier
          index={index}
          shippingNumber={item.shippingNumber}
          onLinkClick={handleCardClick}
          isFirst={isFirst}
        />

        <ShippingDetails 
          shipping={shipping}
          isLoading={isLoading}
        />
      </div>

      <ShippingStatus
        shipping={shipping}
        isLoading={isLoading}
        statusLabel={item.finalStatus?.commercialName || item.finalStatus?.name}
      />
    </Paper>
  );
};

export default ScannedItemCard;
